<!-- 
  Este componente detecta automaticamente a transição de status de conexão com a internet no dispositivo do usuario.
online > offline / offline > online
e exibe uma mensagem na tela se conexao for nula, indicando atividade em modo offline.

para usar basta importar o componente em App.vue na tag v-main (usei antes de router-view)
e instalar v-offline usando "yarn add v-offline"

ps: v-offline possui slots "online" e "offline" para renderização condicional porém o slot offline nao estava renderizando
entao foi realizado v-if mapeando variável em data(). -->

<template>
  <div class="fixed">
    <!-- @detected-condition fires when the connectivity status of the device changes -->
    <offline @detected-condition="handleConnectivityChange">
      <!-- <div slot="offline">
      <p>You appear to be offline, that's okay, we can still do things...</p>
    </div>
    <div slot="online">
      <p>It looks like you're online! Here's all the things you can do...</p>
    </div> -->
    </offline>
    <v-alert
      app
      v-if="!online"
      type="error"
      dense
      border="bottom"
      icon="mdi-wifi-strength-alert-outline"
    >
      <strong>Modo offline</strong> - {{ msg }}
    </v-alert>
  </div>
</template>

<script>
import offline from "v-offline";

export default {
  components: {
    offline,
  },
  data() {
    return {
      online: true,
      msg: "Funcionalidade limitada",
    };
  },
  methods: {
    handleConnectivityChange(status) {
      this.online = status;
    },
  },
  updated() {
    this.online = navigator.onLine;
  },
  created() {
    this.handleConnectivityChange();
    this.online = navigator.onLine;
  },
  mounted() {
    this.online = navigator.onLine;
  },
  watch: {
    online(nv, ov) {
      if (nv) {
        this.$router.go();
      }
    },
  },
};
</script>

<style scoped>
.fixed {
  position: relative;
  width: 100%;
  z-index: 1;
}
</style>
